<template>
  <div class="orb-container">
    <div class="orb" :style="orbStyle">
      <WebGLOrb
        :size="size"
        :isPulsing="stateConfig.isPulsing"
        :intensity="stateConfig.intensity"
        :animationSpeed="stateConfig.animationSpeed"
        :colorPrimary="colorPalette.primary"
        :colorSecondary="colorPalette.secondary"
        :colorTertiary="colorPalette.tertiary"
        :pulseSpeed="stateConfig.pulseSpeed"
        :pulseAmount="stateConfig.pulseAmount"
      />
    </div>
  </div>
</template>

<script>
import WebGLOrb from "./WebGLOrb.vue";

export default {
  name: "OliverOrb",
  components: {
    WebGLOrb,
  },
  props: {
    size: {
      type: Number,
      default: 75,
    },
    state: {
      type: String,
      default: "active",
      validator: (value) => ["active", "speaking"].includes(value),
    },
    colors: {
      type: Array,
      default: () => ["#8F8AE6", "#5B54DB", "#2C25AD"],
    },
  },
  data() {
    return {};
  },
  computed: {
    colorPalette() {
      return {
        primary: this.colors[0],
        secondary: this.colors[1],
        tertiary: this.colors[2],
      };
    },
    stateConfig() {
      const configs = {
        active: {
          animationSpeed: 1.0,
          isPulsing: false,
          intensity: 1.0,
          pulseSpeed: 2.0,
          pulseAmount: 0.05,
        },
        speaking: {
          animationSpeed: 1.5,
          isPulsing: true,
          intensity: 1.3,
          pulseSpeed: 4.0,
          pulseAmount: 0.08,
        },
      };

      return configs[this.state] || configs.active;
    },
    orbStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
};
</script>

<style scoped>
.orb-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.orb {
  position: relative;
  transition: transform 0.3s ease;
  isolation: isolate;
}
</style>
